<script>
import appConfig from "@/app.config.json";
import Layout from "@/views/layouts/main.vue";
import apiEndpoints from "@/services/apiEndpoints";
import sweetAlert from "@/mixins/sweetAlert";
import moment from "moment-timezone";
import { BIconCaretRightFill, BIconCaretLeftFill } from 'bootstrap-vue'
import { dateWithWeekDay } from "@/filters/index"
import DatePicker from "vue2-datepicker";

export default {
  name: "SelectFactory",
  page: {
    title: "工場選択",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout,
    BIconCaretRightFill,
    BIconCaretLeftFill,
    DatePicker
  },
  mixins: [sweetAlert],
  data() {
    return {
      data: [],
      factoryHasDailyReport: [],
      hasSchedule: false,
      paramDate: this.$route.query.date !== undefined ? this.$route.query.date : moment().format("YYYY-MM-DD"),
      sessionDate: this.$route.query.date !== undefined ? this.$route.query.date : moment().format("YYYY-MM-DD"),
    };
  },
  async created() {
    await this.getUserScheduleByDate();
    await this.redirectIfHasScheduleToday();
  },
  methods: {
    async getUserScheduleByDate() {
      this.hasSchedule = false;
      const sendApiProject = await this.$http.get(
        apiEndpoints.schedule_today_of_user, { date: this.paramDate });
      const {status, data} = sendApiProject;

      if (status && data) {
        if (data.result.length != 0) {
          this.hasSchedule = true;
        }
      }
    },
    async getData() {
      const url = apiEndpoints.vendor_sites_select_factory;
      const {status, data} = await this.$http.get(url);
      if (status) {
        this.data = data.result;
      }
    },
    async toListDailyWorkReport(id, name, zz_vendor_site_4_id, discharger_site_id = null) {
      let filters = {
        date: this.paramDate,
        factory_id: id,
        discharger_site_id: discharger_site_id,
      }
      const sendApi = await this.$http.get(apiEndpoints.daily_report_check_factory, filters);
      const { status, data } = sendApi;
      if (status && data.result.length != 0) {
        const params = {
          date: this.paramDate,
          id: id,
          name: name,
          zz_vendor_site_4_id: zz_vendor_site_4_id,
          discharger_site_id: discharger_site_id
        };

        this.$router.push({
          path: "daily-reports-factory/" + zz_vendor_site_4_id,
          query: params,
        });
      } else {
        this.displayAlert('工場には日報がありません', "info", 'null', false, 1500, "top-end")
      }
    },
    backToList() {
      this.paramDate = this.sessionDate
      this.redirectToDailyReport();
    },
    async redirectIfHasScheduleToday() {
      if (this.$route.query.fromMenu == undefined || this.$route.query.fromMenu == 1) {
        if (this.hasSchedule) {
          this.$router.push('daily-reports')
        } else {
          this.getFactories();
        }
      } else {
        this.getFactories();
      }
    },
    async getFactories() {
      await this.getData();
    },
    decrementDate() {
      this.changeDate(-1);
    },
    incrementDate() {
      this.changeDate(1);
    },
    async changeDate(delta) {
      this.sessionDate = this.paramDate;
      let currentDate = moment(this.paramDate, 'YYYY-MM-DD');
      let newDate = currentDate.add(delta, 'days');
      this.paramDate = newDate.format('YYYY-MM-DD');

      this.redirectToDailyReport()
    },
    async redirectToDailyReport() {
      await this.getUserScheduleByDate();
      if (this.hasSchedule) {
        this.$router.push({name: 'daily-reports', query: {date: this.paramDate}})
      }
    },
    formatDateWithWeekDay() {
      return moment(this.paramDate).locale('ja').format('YYYY年MM月DD日（ddd）')
    },
    onChangeSelectedDate(){
      this.redirectToDailyReport();
    }
  }
};
</script>
<template>
  <Layout>
    <b-card>
      <div class="d-flex justify-content-center mb-4">

        <div class="fw-bold">
        <span class="h4 mb-2 cursor-pointer" @click="decrementDate">
          <b-icon-caret-left-fill variant="primary" />
        </span>
        </div>
        <div>
          <span class="grey">
            <date-picker
                lang="ja"
                :clearable="false"
                placeholder="YYYY-MM-DD"
                format="YYYY-MM-DD（ddd）"
                value-type="YYYY-MM-DD"
                position="left"
                type="date"
                v-model="paramDate"
                @change="onChangeSelectedDate"
              >
            </date-picker>
          </span>
        </div>
        <div>
        <span class="h4 mb-2 cursor-pointer" @click="incrementDate">
          <b-icon-caret-right-fill variant="primary" />
        </span>
        </div>
      </div>
      <div class="wrapC mb-4">
        <h5 class="contentC mb-0">工場・積替保管場所</h5>
      </div>
      <template v-for="(item, index) in data">
        <b-row class="centered-buttons mb-3">
          <b-button
            :key="index"
            @click="toListDailyWorkReport(item.id, item.name_abbreviated, item.zz_vendor_site_4_id, item.discharger_site_id)"
            class="btn btn-success btn-lg factory-button"
          >
            <span>{{ item.name_abbreviated }}</span>
          </b-button>
        </b-row>
      </template>
      <template v-if="!data.length">
        <b-row class="d-flex align-items-center justify-content-center">
          <span style="text-align: center;">データなし。</span>
        </b-row>
      </template>
    </b-card>
  </Layout>
</template>
<style lang="scss">
.contentC {
  padding: 10px;
  background: #f8f9fa;
  width: 100%;
}
.factory-button {
  max-width: 315px;
  width: 100%;
  margin-bottom: 6px;
}
.centered-buttons {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
